import React from "react";
import {SvarInputTypeProps} from "./svarInputTypeCompareMap";
import {Datepicker} from "../../../core/components/datePicker/datePicker";
import {Localizer} from "../../../infrastructure/localization/localizer";
import classNames from "classnames";
import {BesvaretAf} from "../readSvar/besvaretAf";

export function DatoInputSvar ({spoergsmaal, svarNummerIndex, kompetenceSvarList, indsendt, dateCallback, readOnly}: SvarInputTypeProps) {
    const stempel = kompetenceSvarList.find(x => x.svarIndex === svarNummerIndex)?.stempel;
    return (
        <>
            <Datepicker
                id={spoergsmaal.id + svarNummerIndex}
                key={spoergsmaal.id + svarNummerIndex}
                additionalClasses={classNames("margin-bottom-s")}
                label={Localizer.evalueringPage_angivDatoFelt()}
                defaultValue={kompetenceSvarList.find(x => x.svarIndex === svarNummerIndex)?.dateSvar}
                allowClear
                disabled={indsendt || readOnly}
                setDate={(date: Date) => dateCallback(svarNummerIndex, date)}
            />
            {stempel &&
                <BesvaretAf
                    stempel={stempel}/>
            }
        </>
    )
}
